import XButton from "./XButton";
import { cn } from "../../utils/classNames"
import Tooltip from "../ui-control/Tooltip";

const iconClasses = 'h-action-icon w-action-icon flex-none';

const iconEnabledClasses = 'text-primary';

const iconDisabledClasses = 'text-white';

// Centered because a lone icon would otherwise sit at the left of a stretched grid cell.
const iconOnlyClasses = 'px-action-icon-only-x justify-center!';

const ActionButton = ({ variant, icon: Icon, label, isIconOnly = false, disabled = false, tooltipTitle, tooltipPlacement, className, ...rest }) => (
    <Tooltip title={tooltipTitle} placement={tooltipPlacement}>
        <XButton
            variant={variant}
            disabled={disabled}
            className={cn(isIconOnly && iconOnlyClasses, className)}
            aria-label={isIconOnly ? label : undefined}
            {...rest}
        >
            {Icon && <Icon className={cn(
                iconClasses,
                disabled ? iconDisabledClasses : iconEnabledClasses
            )} />}
            {!isIconOnly && <span>{label}</span>}
        </XButton>
    </Tooltip>
);

export default ActionButton;
